module.exports = __webpack_public_path__ + "static/easyeducation-extraimg2-min-534270e61695e58959b1ad67e1b92540.jpg";